import React, { useEffect } from 'react';
import { FormattedMessage } from 'react-intl';
import { TransactionSearchOperation } from '../../types';
import Summary from './Summary';
import Status from '../status/Status';
import NoResultView from '../status/NoResultView';
import ButtonTryAgain from '../components/buttons/ButtonTryAgain';

type Props = {
  transactionSearchResult: TransactionSearchOperation;
};

const TransactionStatus = ({ transactionSearchResult }: Props) => {
  useEffect(() => {
  }, [transactionSearchResult.transactionSearcherData.length]);

  return (
    <main>
      {transactionSearchResult.transactionSearcherData.length !== 0 &&
          <Summary transactionSearchResult={transactionSearchResult}/>}
      {transactionSearchResult.transactionSearcherData.length !== 0 ? (
        <div className="column column-2">
          <article className="search-form">
            <header className="row">
              <h1>{<FormattedMessage id="transactionStatus.header" />}</h1>
            </header>
            {transactionSearchResult.transactionSearcherData.map((status) => (

                <Status transactionStatus={status} key={status.orderId} />

            ))}

            <ButtonTryAgain className={"tryAgainScenario"}/>
          </article>
        </div>
      ) : (
        <NoResultView transactionSearchResult={ transactionSearchResult} />
      )}
    </main>
  );
};

export default TransactionStatus;
